export enum TfaOptions {
  googleAuth = 'APPLICATION_AUTHENTICATOR',
  email = 'EMAIL',
  sms = 'SMS',
}
